import React from 'react';
import { Input } from '@rebass/forms';

export const TextFormField = props => (
  <Input
    { ...props }
  />
);
